/* globals zoomSdk */
import axios from 'axios'
import { imageUrlToImageData, getImageDataSizeInKB } from './imageHelpers'

export const sendBackgroundViaAppInvitation = async (image, dispatch) => {
  const anonUserContext = { screenName: '' }
  let userContext = anonUserContext
  let imageData = undefined
  let imageDataSize = Infinity

  try {
    // may fail in certain contexts; default to 'anonymous' user
    userContext = await zoomSdk.getUserContext()
    imageData = await imageUrlToImageData(image?.src?.tiny)
    imageDataSize = getImageDataSizeInKB(imageData)

  } catch (error) {
    console.log('error')
  }

  const { screenName = '' } = userContext
  const imageDataSizeAcceptable = imageDataSize < 500 // sendAppInvitation will timeout if this

  // 1. Create an event handler which:
  const createInvitationEventListener = async (event) => {
    // a) Gets the invitation id from the app invitation event
    const { invitationUUID } = event


    // defensive
    if (!invitationUUID || !event || !imageData) {
      return
    }
    // b) Hits the API and performs create invitation operation
    try {
      await axios.post(
        // optimistic
        '/api/sharing/invitation',
        { invitationId: invitationUUID, image, inviterScreenName: screenName }
      )
    } catch (error) {
      console.log('error')
      return
    }

    // c) Removes itself - createInvitation not performed on subsequent app shares
    await zoomSdk.removeEventListener(
      'sendAppInvitation',
      createInvitationEventListener
    )
  }

  // 2. Register the handler, which will fire when event is fired
  await zoomSdk.onSendAppInvitation(createInvitationEventListener)

  const messageTextEllipsis = screenName.length > 50 ? '...' : ''
  const messageTextScreenName = screenName.substring(0, 50)
  const messageText = `${messageTextScreenName}${messageTextEllipsis} shared a background with you.`

  const dialogOptions = {
    thumbnail: imageData,
    dialogHeading: 'Share Virtual Background',
    messageText,
    dialogButtonText: 'Share',
    primaryButtonText: 'Open',
    secondaryButtonText: 'Dismiss'
  }

  // 3. Open the invitation dialog to kick off the flow (event fired when user sends invitation)
  if (imageData && imageDataSizeAcceptable) {
    try {
      await zoomSdk.callZoomApi('showAppInvitationDialog', dialogOptions)
    } catch (error) {
      console.log('error')
    }
  }
}
